// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/additional_service_prices/salvar.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AdditionalServicePrices_SalvarResponseDados {
so_additional_service_price_id: number
}

export type AdditionalServicePrices_SalvarResponse = ApiResponse<AdditionalServicePrices_SalvarResponseDados>;

registerResponseContract('AdditionalServicePrices_SalvarResponse', {
  so_additional_service_price_id: { type: 'number',  required: true },
})
